import { linkEditorListener } from './linkEditorListener'

export default linkEditorListener
